import React from 'react';
import styled from 'styled-components';

import ScrollContainer from './ScrollContainer';
import Section from './Section';
import Hero from './Hero';
import About from './About';
import Achievements from './Achievements';
import TechStack from './TechStack';
import Projects from './Projects';
import Contact from './Contact';

const HeroTransitionWrapper = styled.div`
  position: relative;
  isolation: isolate;
  width: 100%;
  max-width: 100%;
  overflow-x: clip;
`;

const AboutBackground = styled.div`
  position: absolute;
  top: 100vh;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000;
  z-index: 1;
`;

const MainContent = ({ showSecondary = true }) => {
  return (
    <ScrollContainer>
      <HeroTransitionWrapper>
        {showSecondary && <AboutBackground />}
        
        <Section overflow="visible" background="transparent" style={{ zIndex: 2 }} disableFade>
          <Hero />
        </Section>
        
        {showSecondary && (
          <Section overflow="visible" background="transparent" style={{ zIndex: 3 }} disableFade>
            <About />
          </Section>
        )}
      </HeroTransitionWrapper>

      {showSecondary && (
        <>
          <Achievements />
          <Section background="var(--color-portfolio-ink)">
            <TechStack />
          </Section>
          <Section background="var(--color-portfolio-ink)">
            <Projects />
          </Section>
          <Section background="var(--color-portfolio-silver)" overflow="visible" disableFade>
            <Contact />
          </Section>
        </>
      )}
    </ScrollContainer>
  );
};

export default MainContent;
